import Vue from "vue";
import { appConfig } from "./utils.js";
const api = appConfig.api_path;

export function searchGuests(qryConds) {
  return Vue.http.get(api + 'guest/list', { params: qryConds })
}

export function getGuests(codes) {
  return Vue.http.get(api + 'guest/infos/' + codes, {})
}

export function saveGuest(guest) {
  return Vue.http.post(api + 'guest/save', guest)
}

export function getSForGuestList(code) {
  return Vue.http.get(api + 'sfor_guest/list/' + code, {})
}

export function saveSForGuest(sforguest) {
  return Vue.http.post(api + 'sfor_guest/save', sforguest)
}

export function delSForGuest(sforguest) {
  return Vue.http.post(api + 'sfor_guest/del', sforguest)
}


// WEBPACK FOOTER //
// ./src/api/guest.js